// extracted by mini-css-extract-plugin
export default {"lead":"App_lead__TTwi6","container":"App_container__DWD9s","sectionHead":"App_sectionHead__C+1DP"};